import { AutoComplete, Input } from "antd"
import usePlatform from "contexts/platform/use-platform"
import { IPolicyholder } from "platform-client/types"
import React from "react"
import Highlighted from "components/Highlighted"
import { useQuery } from "react-query"
import styled from "styled-components"
import { useDebounce } from "use-debounce"

const StyledClientRef = styled.span`
  color: #aaa;
`

const StyledClientEmail = styled.span`
  font-style: italic;
  color: #aaa;
`

const SEARCH_DEBOUNCE_MS = 400

const ClientLookup = ({ onSelectClient }: IClientLookupProps): JSX.Element => {
  const [query, setQuery] = React.useState("")
  const [debouncedQuery] = useDebounce(query, SEARCH_DEBOUNCE_MS)
  const platform = usePlatform()

  const { data: clients, isLoading } = useQuery(
    ["client", "search", debouncedQuery],
    () =>
      platform.policyholders.searchPolicyholders({
        searchTerm: debouncedQuery
      }),
    {
      enabled: debouncedQuery.length >= 3
    }
  )

  return (
    <AutoComplete
      style={{ width: "100%" }}
      value={query}
      onChange={setQuery}
      onSelect={(value) => {
        if (typeof onSelectClient === "function") {
          onSelectClient(JSON.parse(value) as IPolicyholder)
        }
      }}
      options={
        Array.isArray(clients)
          ? clients.map((client) => ({
              value: JSON.stringify(client),
              label: (
                <>
                  <Highlighted
                    text={[
                      client.legalName,
                      client.businessName,
                      client.contact?.name?.firstName &&
                        client.contact?.name?.lastName &&
                        client.contact.name.firstName +
                          " " +
                          client.contact.name.lastName
                    ]
                      .filter(Boolean)
                      .join(", ")
                      .trim()}
                    search={query}
                  />
                  {client.contact?.emailAddress && (
                    <>
                      {" - "}
                      <StyledClientEmail>
                        {client.contact.emailAddress}
                      </StyledClientEmail>
                    </>
                  )}
                  {" - "}
                  <StyledClientRef>{client.referenceID}</StyledClientRef>
                </>
              )
            }))
          : []
      }
    >
      <Input.Search size={"large"} loading={isLoading} />
    </AutoComplete>
  )
}

interface IClientLookupProps {
  onSelectClient?: (data: IPolicyholder) => void
}

export default ClientLookup
